import type { SerialKillerDTO } from "@shared/contracts";
import { SerialKillerPicture } from "./SerialKillerPicture";
import { formatDateYMD } from "../../../utils/date";
import { Row, Col, Space } from "antd";
import styled from "styled-components";

interface Props {
  killer: SerialKillerDTO;
}

const DetailSpace = styled(Space)`
  width: 100%;
  font-family: "veterantypewriter", serif !important;
`;

const DetailRow = styled(Row)`
  width: 100%;
`;

const PictureRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const ValueCol = styled(Col)`
  text-align: end;
`;

export function SerialKillerDetailRows({ killer }: Props) {
  const rows: Array<[string, string | number | null]> = [
    ["Name", killer.name ?? null],
    ["Alias", killer.alias ?? null],
    [
      "Date of birth",
      killer.dateOfBirth ? formatDateYMD(killer.dateOfBirth) : null,
    ],
    ["Place of birth", killer.placeOfBirth ?? null],
    [
      "Number of victims",
      typeof killer.numberOfVictims === "number"
        ? killer.numberOfVictims
        : null,
    ],
    ["Status", killer.status ?? null],
    ["Place of arrest", killer.placeOfArrest ?? null],
    ["Span of crime", killer.spanOfCrime ?? null],
    ["Penalty", killer.penalty ?? null],
    ["Place of penalty", killer.placeOfPenalty ?? null],
  ];

  return (
    <DetailSpace direction="vertical" size={8}>
      <PictureRow>
        <SerialKillerPicture
          name={killer.name}
          pictureLink={killer.pictureLink}
        />
      </PictureRow>
      {rows
        .filter(([, v]) => v != null && v !== "")
        .map(([label, value], idx) => (
          <DetailRow key={label + idx} gutter={8}>
            <Col span={8}>{label}</Col>
            <ValueCol span={16}>{value}</ValueCol>
          </DetailRow>
        ))}
    </DetailSpace>
  );
}
